import SectionHeading from "@/components/base/SectionHeading";
import { contentPrinciples } from "@/mocks/site";

export default function PrinciplesSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-shell mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="How We Work"
          title="我们如何整理一条爆料"
          desc="爆料的价值不在于快，而在于能不能被回溯。以下四条是我们处理每条时间线时的固定动作。"
          center
        />
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {contentPrinciples.map((item, index) => (
            <article
              key={item.title}
              className="flex flex-col gap-3 p-6 rounded-lg bg-background-50 border border-background-200"
            >
              <span className="flex items-center justify-between">
                <span className="w-11 h-11 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center text-lg">
                  <i className={item.icon} />
                </span>
                <span className="font-heading text-2xl font-black text-background-300">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </span>
              <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}